var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-dialog",
    {
      attrs: {
        title: _vm.$t("pc_biz_lbl_newfolder" /** 新建文件夹 */),
        visible: _vm.visible,
        "append-to-body": "",
        "before-close": _vm.beforeClose,
        width: "520px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "yxtf-form",
        {
          ref: "form",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "90px",
            "label-position": _vm.labelPosition,
            "show-message": false,
          },
        },
        [
          _c(
            "yxtf-form-item",
            {
              attrs: {
                prop: "parentId",
                label: _vm.$t("pc_biz_lbl_parentfolder" /** 上级文件夹 */),
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.parentName) + "\n    ")]
          ),
          _c(
            "yxtf-form-item",
            {
              attrs: {
                prop: "libName",
                label: _vm.$t("pc_biz_lbl_foldername" /** 文件夹名称 */),
              },
            },
            [
              _c("yxtf-input", {
                attrs: {
                  maxlength: "50",
                  "show-word-limit": "",
                  placeholder: _vm.$t(
                    "pc_biz_lbl_folderplaceholder" /** 请输入文件夹名称 */
                  ),
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                  },
                },
                model: {
                  value: _vm.ruleForm.libName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.ruleForm,
                      "libName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "ruleForm.libName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("CancelButton", {
            on: {
              click: function ($event) {
                _vm.visible = false
              },
            },
          }),
          _c(
            "yxtf-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.save },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_core_btn_confirm")))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }